import { motion } from 'framer-motion';
import MarketingLayout from '../components/MarketingLayout';
import SEO from '../components/SEO';
import PricingSection from '../components/home/PricingSection';

const fadeUp = { initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };
const stagger = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

const faqs = [
  { q: 'Can I try PAFHub before committing?', a: 'Absolutely. You can create a free account with access to core features. No credit card required to start.' },
  { q: 'What happens when I exceed the employee limit?', a: 'We will notify you when you are approaching your limit. You can upgrade your plan at any time, and the change takes effect immediately.' },
  { q: 'Can I switch plans later?', a: 'Yes, you can upgrade or downgrade at any time. When upgrading, you will be prorated for the remainder of your billing cycle.' },
  { q: 'Is there a discount for annual billing?', a: 'Yes! Annual billing saves you 20% compared to monthly pricing. Contact us for annual plan details.' },
  { q: 'What payment methods do you accept?', a: 'We accept all major credit cards, ACH bank transfers, and wire transfers for Enterprise plans.' },
];

export default function PricingPage() {
  return (
    <MarketingLayout>
      <SEO
        title="Pricing"
        description="Simple, transparent pricing for PAFHub. Free plan for small teams, Starter at $15/mo, Professional at $25/mo. No hidden fees. Start managing H-1B compliance today."
        path="/pricing"
        keywords="H-1B compliance software pricing, PAF management cost, immigration compliance software plans"
      />

      {/* SEO-only H1 (visually hidden, fully accessible to search engines & screen readers) */}
      <h1 className="sr-only">PAFHub — Simplify H-1B, H-1B1 & E-3 Public Access Files(PAF) Compliance</h1>

      {/* Identical pricing cards as home page */}
      <div className="pt-20">
        <PricingSection />
      </div>

      {/* FAQ */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <motion.div {...fadeUp} transition={{ duration: 0.5 }} className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#0F172A] tracking-tight mb-4">Frequently asked questions</h2>
          </motion.div>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <motion.div
                key={i}
                {...stagger}
                transition={{ duration: 0.3, delay: i * 0.05 }}
                className="bg-[#F8FAFF] rounded-2xl border border-indigo-100/50 p-6"
              >
                <h4 className="text-sm font-bold text-[#0F172A] mb-2">{faq.q}</h4>
                <p className="text-sm text-[#64748B] leading-relaxed">{faq.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
